function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Link from 'components/Link';
import App from 'modules/App';
import messages from '../../../../messages';
import styles from '../../DownloadDataModal.pcss';
const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
        children: chunk
    });
const AppStoreLinks = ({ countryId })=>{
    const country = useSelector(App.selectors.countryById(countryId));
    const iosUrl = get(country, 'settings.iosStoreURL', null);
    const androidUrl = get(country, 'settings.androidStoreURL', null);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-6",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "brand__paragraph brand__fontSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.appStoreLinksInfo), {
                    values: {
                        b
                    }
                }))
            }),
            /*#__PURE__*/ _jsxs(Link, {
                to: iosUrl,
                className: styles.warnings__stores,
                target: "_blank",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/ios.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "brand__paragraph--bold",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.iOSStore))
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "brand__caption",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.forIOS))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Link, {
                to: androidUrl,
                className: styles.warnings__stores,
                target: "_blank",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/android.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "brand__paragraph--bold",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.androidStore))
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "brand__caption brand__fontSecondary",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.forAndroid))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default AppStoreLinks;
